import React from 'react';
import { useHistory } from 'react-router-dom';
import freedomTheme from 'web_component_library/theme/freedom';
import TertiaryNavigation from 'web_component_library/tertiaryNavigation';
import TertiaryNavigationSectionModel from '../../containers/contentful/tertiaryNavigationSection';
import { isAbsolutePath } from '../ctaAnalyticsHoc';

const TertiaryNavigationSection = props => {
  const {
    buttonsVariants,
    iconsList,
    iconsVariant,
    identifier,
    restrictContent,
  } = new TertiaryNavigationSectionModel(props);
  const history = useHistory();
  const { colors } = freedomTheme;

  if (!iconsList) return null;

  const onClick = url => {
    if (isAbsolutePath(url)) {
      window.location.href = url;
    } else {
      history.push(url);
    }
  };

  return (
    <TertiaryNavigation
      buttonsList={iconsList}
      buttonsVariant={colors[buttonsVariants]}
      iconsVariant={iconsVariant}
      identifier={identifier}
      onClick={onClick}
      restrictContent={restrictContent}
    />
  );
};

export default TertiaryNavigationSection;
